import { useMutation } from 'urql';
import { FrequencyOnNewsletterDocument } from '@packages/gql/generated/shopping/FrequencyOnNewsletterDocument';

/* GraphQL */ `
  mutation FrequencyOnNewsletter($emailAddress: String!, $frequency: String!) {
    changeNewsletterRecipient(
      frequencyRequestData: { emailAddress: $emailAddress, frequency: $frequency }
    ) {
      ... on SubscribeResponseData {
        success
      }
      ... on ErrorResponse {
        errors
      }
    }
  }
`;
export const useFrequencyNewsletterGql = () => {
  const [, executeMutation] = useMutation(FrequencyOnNewsletterDocument);
  return executeMutation;
};
